import { render, staticRenderFns } from "./RoomBooking.vue?vue&type=template&id=c29c362c&scoped=true&"
import script from "./RoomBooking.vue?vue&type=script&lang=ts&"
export * from "./RoomBooking.vue?vue&type=script&lang=ts&"
import style0 from "./RoomBooking.vue?vue&type=style&index=0&id=c29c362c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c29c362c",
  null
  
)

export default component.exports